import PostList from './PostList';
import PostIcon from '@material-ui/icons/PermIdentity';
import AmbassadorIcon from '@material-ui/icons/Business';
import PostEdit from './PostEdit';
import CommissionList from './CommissionList';
import CommissionIcon from '@material-ui/icons/AttachMoney';

export default {
    icon: AmbassadorIcon,
    post: PostList,
    postEdit: PostEdit,
    postIcon: PostIcon,
    commission: CommissionList,
    commissionIcon: CommissionIcon,
};
